module.exports = __webpack_public_path__ + "img/FC.22dfff97.png";